export class NotificationOpen  {
  public static readonly type = '[Notification] NotificationOpen';
  constructor(public data: string, public close?: boolean) {}
}
export class NotificationClose  {
  public static readonly type = '[Notification] NotificationClose';
  constructor() {}
}
